// extracted by mini-css-extract-plugin
export default {"borderTopBottomNone":"Sidebar_borderTopBottomNone__HjlUR","dividerTop":"Sidebar_dividerTop__OPfJ1","bodyHeight":"Sidebar_bodyHeight__fonZ9"};